export default "https://cdn-static.gokick.com/assets/4e1d6b599b0c658e33aa5c1b8604da35a9a49f05/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";